import type { TFunction } from "@/hooks/useTranslation"
import type { IssueImpact } from "./ImpactCard.types"

export const getImpactedApplicationsCount = (issue: IssueImpact) => {
  if (!issue) return 0

  const { active, inactive } = issue.applicationCount

  return active + inactive
}

export const getEnvironmentLabel = (issue: IssueImpact, t: TFunction) => {
  if (!issue) return null

  const { applicationCount: meta } = issue
  const count = meta.environments.length

  if (meta.total === 0) return null

  return t("triage.drawer.impact.acrossEnvs", {
    count,
    environment: meta.environments[0]
  })
}

export const getApplicationsLabel = (
  issue: IssueImpact,
  props: { kortexInstalled: boolean | undefined; t: TFunction }
) => {
  const { kortexInstalled, t } = props

  if (!issue) return t("triage.drawer.impact.checkingRuntimeImpact")

  const { applicationCount: meta } = issue

  const { total, terminated } = meta

  if (total === 0) {
    if (issue.applicationsMeta.isVM)
      return t("triage.drawer.impact.empty.noApplicationVm")

    return t(
      kortexInstalled
        ? "triage.drawer.impact.empty.noApplication"
        : "triage.drawer.impact.empty.noApplicationNoSensor"
    )
  }

  const live = getImpactedApplicationsCount(issue)
  const liveText = t("triage.drawer.impact.live", { count: live })
  const terminatedText =
    terminated > 0
      ? `, ${t("triage.drawer.impact.terminated", { count: terminated })}`
      : ""

  return `${liveText}${terminatedText} ${getEnvironmentLabel(issue, t) || ""}`
}
